var render, staticRenderFns
import script from "./KButtonGroup.vue?vue&type=script&lang=js&"
export * from "./KButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./KButtonGroup.vue?vue&type=style&index=0&id=dfa51ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa51ee4",
  null
  
)

export default component.exports